/* eslint-disable import/no-unresolved */
import { z } from 'zod';

/**
 * Transforms object keys from snake_case to camelCase
 */
function toCamelCase(str: string): string {
  return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
}

/**
 * Maps all keys of an object using the provided transform function
 */
function mapKeys<T extends Record<string, unknown>>(
  obj: T,
  transform: (key: string) => string
): Record<string, unknown> {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [transform(key), value])
  );
}

/**
 * Creates a new Zod schema from the specified schema that will
 * accept all fields in snake case notation and transform them to camel case.
 * @param schema
 */
export function fromSnakeCaseSchema<T extends z.ZodTypeAny>(schema: T) {
  return z
    .any()
    .transform((record) =>
      mapKeys(record as Record<string, string>, toCamelCase)
    )
    .pipe(schema);
}
